<template>
  <b-container>
    <h1 v-translate>Edit Profile</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <profile-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
          <h5 v-translate>Profile was updated!</h5>
        </b-alert>
        <form class="" role="form">
          <div class="row">
            <h3 class="col-12" v-translate>Personal Info</h3>
            <div class="form-group col-md-12">
              <label class="control-label" v-translate>Profile Picture</label>
              <div v-show="user.profile_picture">
                <b-img v-if="user.profile_picture" rounded="circle" :src="user.profile_picture" width="50" height="50" blank-color="#777" alt="img" class="m-1" />
                <b-button v-b-modal.modalUploadImage>
                  <translate>Change Photo</translate>
                </b-button>
              </div>
              <div v-show="!user.profile_picture">
                <b-img v-if="!user.profile_picture" rounded="circle" src="https://www.gravatar.com/avatar/default?s=50&r=pg&d=mm" width="50" height="50" blank-color="#777" alt="img" class="m-1" />
                <b-button v-b-modal.modalUploadImage v-translate>Add Photo</b-button>
              </div>
            </div>
            <div class="form-group col-md-12">
              <label class="control-label" v-translate>Name</label>
              <input class="form-control col-md-6" type="text" v-model="user.name">
            </div>
            <div class="form-group col-md-12">
              <label class="control-label" v-translate>Email</label>
              <input class="form-control col-md-6" type="text" v-model="user.email">
            </div>
            <div class="form-group col-sm-6">
              <label class="control-label" v-translate>Mobile Phone</label>
              <b-form-input v-if="!user.phone" class="form-control" disabled />
              <cleave ref="phoneControl" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" :value="user.phone" v-else disabled></cleave>
            </div>
            <div class="form-group col-sm-6">
              <label class="control-label d-none d-sm-block">&nbsp;</label>
              <b-btn v-b-modal.modalEnterPhone block class="" v-if="user.phone" v-translate>Change your mobile phone</b-btn>
              <b-btn v-b-modal.modalEnterPhone block class="" v-if="!user.phone" v-translate>Enter and verify your mobile phone</b-btn>
            </div>
            <div class="form-group col-sm-6" v-if="user.profile_address !== null">
              <label for="from_extra" v-translate>Street and number</label>
              <div class="input-group">
                <textarea class="form-control" type="text" :value="user.profile_address.place.formatted_address" disabled>{{user.profile_address.place.formatted_address}}</textarea>
              </div>
            </div>
            <div class="form-group col-sm-6 col-lg-3" v-if="user.profile_address !== null">
              <label for="address_extra" v-translate>Floor, door, etc.</label>
              <div class="input-group">
                <b-form-input id="address_extra" name="address_extra" :value="user.profile_address.address_extra" class="" disabled />
              </div>
            </div>
            <div class="form-group col-lg-3">
              <label class="control-label d-none d-lg-block">&nbsp;</label>
              <b-btn v-if="user.profile_address_id !== null" v-b-modal.modalEnterAddress block v-translate>Change address</b-btn>
              <label class="control-label" v-if="user.profile_address === null" v-translate>Address</label>
              <b-btn v-if="user.profile_address_id === null" v-b-modal.modalEnterAddress block v-translate>Enter your address</b-btn>
            </div>
          </div>
          <div class="row text-left">
            <div class="form-group col-12 form-actions">
              <label class="col-md-3 control-label"></label>
              <div class="col-md-8">
                <b-button variant="primary" size="lg" @click.prevent="submit()" v-translate>Save Changes</b-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <b-modal id="modalUploadImage" ref="modalUploadImage" :hide-footer="true">
      <div slot="modal-title" v-translate>Add a new profile image</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <profile-picture-uploader @updateProfileImage="updateProfileImage" />
    </b-modal>
    <b-modal id="modalEnterPhone" ref="modalEnterPhone" :hide-footer="true" @shown="focusPhoneInput">
      <div slot="modal-title" v-translate>Verify your mobile phone</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <phone-validation ref="phoneValidation" @cancel="closeModalPhone" @success="successModalPhone" />
    </b-modal>
    <b-modal id="modalEnterAddress" ref="modalEnterAddress" :hide-footer="true" @shown="focusAddressInput">
      <div slot="modal-title" v-translate>Enter Your Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <add-address ref="addAddress" :ignoreArea="true" :isProfile="true" @cancel="closeModalAddress" @success="successModalAddress" />
    </b-modal>
  </b-container>
</template>
<script>
import store from '@/store/index'
import ProfilePictureUploader from '@/components/ProfilePictureUploader'
import Cleave from 'vue-cleave'
import ProfileNavigation from '@/components/ProfileNavigation'
import AddAddress from '@/components/AddAddress'
import PhoneValidation from '@/components/PhoneValidation'
import { mapGetters } from 'vuex'
import { FETCH_PROFILE, UPDATE_USER } from '@/store/actions.type'
export default {
  name: 'ProfileEditPage',
  title() {
    return this.$gettext('Personal Info « Edit Profile')
  },
  components: {
    ProfilePictureUploader,
    Cleave,
    ProfileNavigation,
    PhoneValidation,
    AddAddress
  },
  data() {
    return {
      formSaved: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      validate: {
        phone: {
          number: '+' + this.$cookies.get('phonePrefix'),
          step: 1,
          code: null
        },
        address: {
          reference: 'profile',
          place_id: null,
          address_extra: null,
          favourite: false,
          display: null,
          id: null
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isLoading'
    ])
  },
  created() {
    this.user.profile_address = {
      place: {
        formatted_address: null
      }
    }
    this.fetchProfile()
  },
  methods: {
    updateProfileImage(url) {
      this.user.profile_picture = url
      this.$store.dispatch(UPDATE_USER, { profile_picture: url }).then(response => {
        this.$refs.modalUploadImage.hide()
        this.showAlert()
      }, error => {
        let obj = {
          title: this.$gettext('ERROR'),
          message: error.body.message,
          type: 'error'
        }
        this.$parent.$refs.simplert.openSimplert(obj)
      })
    },
    fetchProfile() {
      this.$store.dispatch(FETCH_PROFILE)
        .then(response => {
          store.commit('setEmail', this.user.email)
          let payload = { profile: this.user }
          store.commit('setProfile', payload)
          if (this.user.profile_address_id === null) {
            this.user.profile_address = {
              place: {
                formatted_address: null
              }
            }
          }
        })
    },
    focusPhoneInput() {
      this.$refs.phoneValidation.$refs.phoneInput.$el.focus()
    },
    closeModalPhone() {
      this.$refs.modalEnterPhone.hide()
    },
    successModalPhone() {
      this.fetchProfile()
      this.$refs.modalEnterPhone.hide()
    },
    focusAddressInput() {
      this.$refs.addAddress.$refs.addressAutocomplete.$el.children[0].focus()
    },
    closeModalAddress() {
      this.$refs.modalEnterAddress.hide()
    },
    successModalAddress() {
      this.fetchProfile()
      this.$refs.modalEnterAddress.hide()
    },
    submit() {
      delete this.user.phone
      delete this.user.company_id
      delete this.user.roles
      delete this.user.vehicles
      this.$store.dispatch(UPDATE_USER, this.user).then(response => {
        this.showAlert()
        this.fetchProfile()
      }, error => {
        let obj = {
          title: this.$gettext('ERROR'),
          message: error.body.message,
          type: 'error'
        }
        this.$parent.$refs.simplert.openSimplert(obj)
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}

</script>
<style lang="scss">
.vue_component__upload--image {
  #upload_image_form--default {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: #e0ffff;
    color: dimgray;
    padding: 20px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  &.dragover {
    #upload_image_form--default {
      background: #add8e6;

    }
  }

  .upload_image_form__thumbnails {

    .upload_image_form__thumbnail {
      span {
        top: 0;
        color: #fff;
        width: 20px;
        height: 20px;
      }
    }
  }
}

</style>
